import { Divider as DividerBase } from 'semantic-ui-react';
import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Divider = styled(DividerBase)`
  margin: 2rem 0 !important;
`;
